module.exports = __webpack_public_path__ + "static/img/6265_phase_function_Paper_PointsHejduk_Prediction.2b22831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6265_phase_function_Paper_PointsHejduk_Prediction.png
// module id = oNmW
// module chunks = 0